<template>
  <div class="all_candidates">
    <div class="header_tab">
      <div class="left">
        <div class="tab_item" :class="tabValue==item.id?'active_tab_item':''" v-for="item in tabData" :key="item.id">
          {{ item.label }}({{ item.value }})
        </div>
      </div>
      <div class="right">报名时间</div>
    </div>
    <div class="all_person">
      <div class="person_box">
        <div class="top_info">
          <img src="../../assets/img/company/detial/zhongbiao/ava2.png" alt="">
          <div class="right_info">
            <div class="name_line"><span class="name">小明同学</span><span>好评率：<span style="color: #FF8A00;">0%</span></span></div>
            <div class="time">2025-08-16 15:30:00报名</div>
          </div>
        </div>
        <div class="footer_info">
          <div class="icon">隐</div>
          <div class="line"></div>
          <div class="show_tip"><i class="el-icon-lock"></i>报名内容隐私保护，仅需求方可见</div>
          <div class="line"></div>
        </div>
        <div class="image_box">
          <img src="../../assets/img/company/detial/zhongbiao/icon2.png" alt="">
        </div>

      </div>
      <div class="person_box">
        <div class="top_info">
          <img src="../../assets/img/company/detial/zhongbiao/ava1.png" alt="">
          <div class="right_info">
            <div class="name_line"><span class="name">王大顺</span><span>好评率：<span style="color: #FF8A00;">0%</span></span></div>
            <div class="time">2025-08-16 13:00:00报名</div>
          </div>
        </div>
        <div class="footer_info2">
          <div class="show_detial"><span class="label">报价：</span>
            <div class="value" style="color: #FF8A00 ;">1000金币</div>
          </div>
          <div class="show_detial"><span class="label">说明：</span>
            <div class="value">
              <ul>
                <li>LOGO动态化：将企业LOGO拆解为关键元素（如字母、图形），通过动画（缩放、位移、粒子重组）增强记忆点。 </li>
                <li>色彩与字体：严格遵循企业VI系统，主色占比≥60%，辅色点缀，字体保持商务或科技感。 </li>
                <li>科技公司：采用蓝/银色调、光线流动、数据粒子等元素，节奏快（0.5秒/镜头）。</li>
                <li class="no_li">动画逻辑</li>
                <li> 传统行业：用稳重的渐显/平移，搭配金属质感或丝绸纹理，节奏舒缓（1-2秒/镜头）。 </li>
                <li>开场吸引：用动态背景（如星空、线条网）引导视线至LOGO。</li>
                <li>核心展示：LOGO演绎（如立体旋转、粒子聚合）+Slogan浮现。 </li>
                <li>收尾简洁：定格品牌信息，避免冗余元素。</li>

              </ul>
            </div>
          </div>
          <div class="show_detial"><span class="label">链接：</span>
            <div class="value" style="color: #1890FF ;"><i class="el-icon-link" style="margin-right: 5px;"></i><span style="  text-decoration-line: underline;">李小英作品在线链接</span></div>
          </div>
          <div class="show_detial"><span class="label">附件：</span>
            <div class="value">
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/pdf-icon.png" alt=""> 科技封面效果图.jpg <i class="el-icon-download"></i>
              </div>
              <div class="jpg_box"><img src="../../assets/img/company/detial/zhongbiao/img1.png" alt=""></div>
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/video-icon.png" alt=""> 公司片头视频预览.mp4 <i class="el-icon-download"></i>
              </div>
              <div class="jpg_box">
                <img src="../../assets/img/company/detial/zhongbiao/img2.png" alt="">
                <div class="circle"><i class="el-icon-caret-right"></i></div>
              </div>
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/doc-icon.png" alt=""> 作品说明详细介绍.docx <i class="el-icon-download"></i>
              </div>
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/pdf-icon.png" alt=""> 关于公司片头科技风的设计与制作思路详情说... .pdf<i class="el-icon-download"></i>
              </div>
            </div>
          </div>
          <div class="show_detial"><span class="label">评论（{{views.length}}）</span>
            <div class="value" style="color: #1890FF ;"><i class="el-icon-d-arrow-right" style="margin-right: 5px;"></i></div>
          </div>
          <div class="show_detial"><span class="label">
              <img style="width: 40px;height: 40px;border-radius: 50%;margin-right: 10px;" src="../../assets/img/company/detial/zhongbiao/ava1.png" alt="">
            </span>
            <div class="value" style="color: #1890FF ;flex: 1;"><el-input v-model="inputValue" style="width: 100%;" placeholder="说点什么..."></el-input></div>
          </div>
          <div class="button"><el-button style="border: none;" @click="viewContent">评论</el-button></div>
          <div class="show_detial">
            <span class="label"></span>
            <div class="value">
              <div class="view_box" v-for="(item,index) in views">
                <img src="../../assets/img/company/detial/zhongbiao/ava1.png" alt="">
                <div class="view_detial">
                  <div class="name">王大顺</div>
                  <div class="view_content">
                    <div class="content">{{ item }}</div>
                    <el-link :underline="false" @click="deleteView(index)">删除</el-link>
                  </div>
                </div>
              </div>
            </div>

          </div>

        </div>
        <div class="image_box">
          <img src="../../assets/img/company/detial/zhongbiao/icon1.png" alt="">
        </div>

      </div>
      <div class="person_box">
        <div class="top_info">
          <img src="../../assets/img/company/detial/zhongbiao/ava3.png" alt="">
          <div class="right_info">
            <div class="name_line"><span class="name">王德发</span><span>好评率：<span style="color: #FF8A00;">0%</span></span></div>
            <div class="time">刚刚</div>
          </div>
        </div>
        <div class="footer_info2">
          <div class="show_detial"><span class="label">报价：</span>
            <div class="value" style="color: #FF8A00 ;">1000金币</div>
          </div>
          <div class="show_detial"><span class="label">说明：</span>
            <div class="value">
             123
            </div>
          </div>
          <!-- <div class="show_detial"><span class="label">链接：</span>
            <div class="value" style="color: #1890FF ;"><i class="el-icon-link" style="margin-right: 5px;"></i><span style="  text-decoration-line: underline;">李小英作品在线链接</span></div>
          </div> -->
          <div class="show_detial"><span class="label">附件：</span>
            <div class="value">
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/doc-icon.png" alt=""> 脚本.docx <i class="el-icon-download"></i>
              </div>
              <!-- <div class="jpg_box"><img src="../../assets/img/company/detial/zhongbiao/img1.png" alt=""></div>
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/video-icon.png" alt=""> 公司片头视频预览.mp4 <i class="el-icon-download"></i>
              </div>
              <div class="jpg_box">
                <img src="../../assets/img/company/detial/zhongbiao/img2.png" alt="">
                <div class="circle"><i class="el-icon-caret-right"></i></div>
              </div>
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/doc-icon.png" alt=""> 作品说明详细介绍.docx <i class="el-icon-download"></i>
              </div>
              <div class="show_file_name">
                <img src="../../assets/img/company/detial/zhongbiao/pdf-icon.png" alt=""> 关于公司片头科技风的设计与制作思路详情说... .pdf<i class="el-icon-download"></i>
              </div> -->
            </div>
          </div>
          <!-- <div class="show_detial"><span class="label">评论（{{views.length}}）</span>
            <div class="value" style="color: #1890FF ;"><i class="el-icon-d-arrow-right" style="margin-right: 5px;"></i></div>
          </div>
          <div class="show_detial"><span class="label">
              <img style="width: 40px;height: 40px;border-radius: 50%;margin-right: 10px;" src="../../assets/img/company/detial/zhongbiao/ava3.png" alt="">
            </span>
            <div class="value" style="color: #1890FF ;flex: 1;"><el-input v-model="inputValue" style="width: 100%;" placeholder="说点什么..."></el-input></div>
          </div>
          <div class="button"><el-button style="border: none;" @click="viewContent">评论</el-button></div>
          <div class="show_detial">
            <span class="label"></span>
            <div class="value">
              <div class="view_box" v-for="(item,index) in views">
                <img src="../../assets/img/company/detial/zhongbiao/ava3.png" alt="">
                <div class="view_detial">
                  <div class="name">王德发</div>
                  <div class="view_content">
                    <div class="content">{{ item }}</div>
                    <el-link :underline="false" @click="deleteView(index)">删除</el-link>
                  </div>
                </div>
              </div>
            </div>

          </div> -->

        </div>
        <!-- <div class="image_box">
          <img src="../../assets/img/company/detial/zhongbiao/icon1.png" alt="">
        </div> -->

      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      tabData: [
        { label: "全部", id: 1, value: 5 },
        { label: "中标", id: 2, value: 0 },
        { label: "备选", id: 3, value: 1 },
        { label: "淘汰", id: 4, value: 0 },
      ],
      tabValue: 1,
      inputValue: "",
      views: [
        "这个作品，令人深思而欣慰，以平实的真情打动读者，高端的逼格，一气呵成，心理刻画和细节描写都很成功，给人回味之感！从设计的角度来讲选材很是新颖，角度清晰可见，手法平实而不失采，简洁而富有寓意，堪称现代作品之典范！",
      ],
    };
  },
  mounted() {},
  methods: {
    viewContent() {
      if (!this.inputValue.trim()) {
        this.$message.warning("评论内容不能为空！");
      } else {
        this.views.push(this.inputValue);
        this.inputValue = "";
      }
    },
    deleteView(index) {
      this.$confirm("是否删除评论?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.views.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>
<style lang='scss' scoped>
.all_candidates {
  .header_tab {
    display: flex;
    justify-content: space-between;
    height: 60px;
    align-items: center;
    padding: 0 40px;
    box-sizing: border-box;
    background: #ffffff;
    .left {
      display: flex;
      .tab_item {
        margin-right: 20px;
      }
      .active_tab_item {
        color: #384beb;
      }
    }
    .right {
    }
  }
  .all_person {
    .person_box {
      margin-top: 20px;
      background: #ffffff;
      position: relative;
      .top_info {
        height: 100px;
        display: flex;
        padding: 20px;
        box-sizing: border-box;
        border-bottom: 1px solid #e9e9e9;
        img {
          width: 60px;
          height: 60px;
          margin-right: 20px;
        }
        .right_info {
          .name_line {
            font-weight: 500;
            font-size: 14px;
            color: #999999;
            margin-bottom: 7px;
            .name {
              font-weight: 500;
              font-size: 18px;
              color: #333333;
              margin-right: 10px;
            }
          }
          .time {
            font-weight: 400;
            font-size: 14px;
            color: #999999;
          }
        }
      }
      .footer_info {
        height: 126px;
        display: flex;
        align-items: center;
        padding: 0 40px;
        .icon {
          width: 22px;
          height: 24px;
          background: #eb4e4e;
          border-radius: 4px 4px 4px 4px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 22px;
          text-align: center;
          margin-right: 43px;
        }
        .line {
          flex: 1;
          height: 0px;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid #d9d9d9;
        }
        .show_tip {
          width: 262px;
          height: 46px;
          background: #fff3f3;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #ff1111;
          margin: 0 10px;
          font-size: 14px;
          color: #ff3c3c;
          display: flex;
          align-items: center;
          justify-content: center;
          .el-icon-lock {
            font-size: 22px;
            font-weight: 500;
            margin-right: 5px;
          }
        }
      }
      .footer_info2 {
        padding: 20px 100px;
        box-sizing: border-box;
        .show_detial {
          display: flex;
          margin-bottom: 20px;
          .label {
          }
          .value {
            flex: 1;
            .show_file_name {
              margin-bottom: 10px;
              color: #2196f3;
              img {
                width: 16px;
                height: 16px;
                margin-right: 5px;
              }
              .el-icon-download {
                color: #2196f3;
                font-weight: 600;
                font-size: 18px;
                margin-left: 5px;
                cursor: pointer;
              }
            }
            .jpg_box {
              width: 320px;
              height: 180px;
              margin-bottom: 20px;
              position: relative;
              img {
                width: 100%;
                height: 100%;
              }
              .circle {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                width: 58px;
                height: 58px;
                background: rgba(255, 255, 255, 0.1);
                border-radius: 0px 0px 0px 0px;
                color: #fff;
                font-size: 40px;
                border-radius: 50%;
                text-align: center;
                line-height: 58px;
              }
            }
            .el-icon-d-arrow-right {
              transform: rotate(-90deg);
              color: #333333;
              font-size: 20px;
            }
            .view_box {
              display: flex;
              padding: 16px 24px 24px 16px;
              box-sizing: border-box;
              width: 100%;
              background: #f6f6f6;
              border-radius: 4px 4px 4px 4px;
              margin-bottom: 10px;
              img {
                width: 40px;
                height: 40px;
                flex-shrink: 0;
                border-radius: 50%;
              }
              .view_detial {
                flex: 1;
                width: 0;
                margin-left: 10px;

                .name {
                  font-weight: bold;
                  font-size: 14px;
                  color: #333333;
                  margin-bottom: 10px;
                }
                .view_content {
                  display: flex;
                  // align-items: center;
                  .content {
                    flex: 1;
                    width: 0;
                  }
                }
                .el-link {
                  width: 28px;
                  height: 22px;
                  flex-shrink: 0;
                  margin-left: 40px;
                  color: #ff0000;
                }
              }
            }
          }
        }
        .button {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 20px;
          .el-button {
            width: 80px;
            height: 32px;
            background: #c8c9cc;
            border-radius: 16px 16px 16px 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
          }
        }
      }
      .image_box {
        width: 160px;
        height: 136px;
        position: absolute;
        right: 30px;
        top: 40px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
li {
  position: relative;
  padding-left: 10px;
}
ul li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 8px; /* 垂直居中对齐文本 */
  width: 6px; /* 小点宽度 */
  height: 6px; /* 小点高度 */
  border-radius: 50%; /* 圆形 */
  background-color: #666666; /* 蓝色小点，可自定义颜色 */
}
.no_li {
  padding-left: 0 !important;
  &::before {
    background-color: transparent !important; /* 蓝色小点，可自定义颜色 */
  }
}
</style>
